export default __webpack_public_path__ + "static/media/dhl.bcef1784.svg";